import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { resolveUserStationId } from "../services/stationsService";

// Lê o posto do query param `?station={stationId}`. Sem o parâmetro na URL,
// resolve o posto do usuário logado e o coloca na URL (sem nova entrada no histórico).
export function useUserStationParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const stationId = searchParams.get("station") ?? "";
  const [resolving, setResolving] = useState(!stationId);

  useEffect(() => {
    if (stationId) {
      setResolving(false);
      return;
    }

    let active = true;
    setResolving(true);
    resolveUserStationId()
      .then((userStationId) => {
        if (!active) return;
        if (userStationId) {
          setSearchParams({ station: userStationId }, { replace: true });
        } else {
          setResolving(false);
        }
      })
      .catch(() => {
        if (!active) return;
        toast.error("Erro ao identificar o posto do usuário.");
        setResolving(false);
      });

    return () => {
      active = false;
    };
  }, [stationId, setSearchParams]);

  return { stationId, resolving };
}
